import React, { Component } from 'react';
import { Map, InfoWindow, GoogleApiWrapper, Polygon, Marker } from 'google-maps-react';
import { Colors, baseUrl, AppList } from '@capcenter/shared';
import Color from 'color';
import numeral from 'numeral';
import './ServiceAreaMap.scss';

export class ServiceAreaMap extends Component {
  componentDidMount() {
    this.props.setGoogle(this.props.google);
  }

  render() {
    const officeIcon = baseUrl + AppList.siteMap.url + '/svg-icons/property-details.svg';

    const icon = {
      url: officeIcon, // url
      scaledSize: new this.props.google.maps.Size(30, 30), // scaled size
    };

    return (
      <>
        <Map
          google={this.props.google}
          streetViewControl={false}
          mapTypeControl={false}
          zoom={this.props.zoom}
          initialCenter={this.props.initialCenter}
          containerStyle={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 200,
          }}
        >
          {this.props.locations.map((location, i) => {
            if (location.lat && location.lng && location.address) {
              let addressUrl = '';

              location.address.map(line => {
                addressUrl = addressUrl + line.toString() + ' ';
                return null;
              });

              return (
                <InfoWindow
                  key={i}
                  position={{ lat: location.lat, lng: location.lng }}
                  onClose={() => this.props.setId('none')}
                  visible={this.props.currentCounty === location.regionId}
                >
                  <div style={{ overflow: 'hidden' }}>
                    <strong>{location.title}</strong>
                    <br />
                    <a
                      style={{ color: Colors.black500 }}
                      href={'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(addressUrl)}
                    >
                      {location.address.map((line, ii) => (
                        <span key={i}>
                          {line}
                          <br />
                        </span>
                      ))}
                    </a>
                  </div>
                </InfoWindow>
              );
            }

            return null;
          })}

          {this.props.locations.map((location, i) => {
            if (location.lat && location.lng) {
              return (
                <Marker
                  key={i}
                  visible={true}
                  onClick={() => this.props.setId(location.regionId)}
                  position={{ lat: location.lat, lng: location.lng }}
                  icon={icon}
                />
              );
            }
            return null;
          })}

          {this.props.polygons.map((county, i) => (
            <Polygon
              key={i}
              onClick={() => this.props.setId(county.cData.CountyId)}
              paths={county.coords}
              strokeColor={
                county.cData.IsRealtyApplied
                  ? this.props.currentCounty === county.cData.region
                    ? Color(Colors.teal600).string()
                    : Color(Colors.red500).string() // outline of mortgage & realty
                  : Color(Colors.orange500).string() // outline of mortgage only
              }
              strokeOpacity={this.props.currentCounty === county.cData.CountyId ? 1 : 0.8}
              strokeWeight={0.4}
              fillColor={
                county.cData.IsRealtyApplied
                  ? this.props.currentCounty === county.cData.region
                    ? Color(Colors.teal600).string()
                    : Color(Colors.red500).string() // inside of mortgage & realty
                  : Color(Colors.orange500).string() // inside of mortgage only
              }
              fillOpacity={this.props.currentCounty === county.cData.CountyId ? 0.9 : 0.5}
            />
          ))}

          {this.props.polygons.map((county, i) => (
            <InfoWindow
              key={i}
              onClose={() => this.props.setId('none')}
              position={{
                lat: county.extremes.center.lat + (county.extremes.maxLatitude - county.extremes.center.lat) / 2,
                lng: county.extremes.center.lng,
              }}
              visible={this.props.currentCounty === county.cData.CountyId}
            >
              <div style={{ overflow: 'hidden' }}>
                <strong>
                  {county.county}, {county.state} (County)
                </strong>
                {/*#{county.cData.CountyId}*/}
                <br />
                FHA Loan Limit: ${numeral(county.cData.FHALimit).format('0,0')}
                <br />
                Conforming Loan Limit: ${numeral(county.cData.AmountLimit).format('0,0')}
                <br />
                Region: {county.cData.region}
                <br />
                <br />
                <i
                  className="fas fa-square"
                  style={{ color: county.cData.IsRealtyApplied ? Colors.red500 : Colors.orange500 }}
                />
                &nbsp; {county.cData.IsRealtyApplied ? 'Realty & Mortgage Services Offered' : 'Mortgage Services Offered'}
              </div>
            </InfoWindow>
          ))}
        </Map>
      </>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyCdvaMHNx50PAJqYNH4708oC18aPnDdFVA',
})(ServiceAreaMap);
